<template>
    <div class="w-100">
		
		<div class="d-flex justify-content-center align-items-center w-100"  v-if="Object.keys(walletAccount).length > 0 &&  parseInt(get_user.verified_status) >= 1">
			<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && authComponent && transaction_id != '' && !congModuleIntTransfer)">
				<app-twofa  :call_from="request_page"></app-twofa>
			</div>
			<div class="middleBox"  v-else>
				<div class="mainTitle text-center mt-4 mb-3"> 
					<h2 class=" mb-3">{{$t('loyalP_Transfer')}} </h2>
					<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
					<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
				</div> 
				<!--loader - message--->
				
				<!-------------------->
				<div class="CustomBlockWidth inMiddle-area whitebox p-4"> 
					<div class="justify-content-center"> 
						<!----------------------request form---------------------------------> 
						<div class="partcipate-fund" v-if="transaction_id == '' && !congModuleIntTransfer">
							<div class="col-12 p-0" :class="$parent.transfetWallet?'d-block':'d-none'">
					        	<div class="CustomBlockWidth whiteBG border-radius">
						        	<div class="pointTransfer">
						        		<!-- <h4 class="mb-3">Transfer Wallet ID <span class="green">173562</span> </h4>-->
						        		<div class="historyDeposit d-flex complete mb-4 wlt w-100">
											
											<ul class="historyList d-flex w-100">
												<li class="pr-2">
													<div class="blockIDArea p-3 w-100 d-flex align-items-center">
														<!-- <span class="historyList-icon">
															<img src="../../../../../static/fxView/images/eur.svg" class="data_currency">
														</span> --> 
														<span class="blockID">
															<span class="tI">{{$t('loyalP_transf_TotalP')}}</span> 
															<span class="tL">{{loyalityCardDetail[0].issued_points}}</span>
														</span>
													</div> 
												</li> 
												<!-- <li class="px-2">
													<div class="blockIDArea p-3">
														<span class="blockID">
															<span class="tI">Amount Reserved</span> 
															<span class="tL">{{loyalityCardDetail[0].used_points}} </span>
														</span>
													</div> 
												</li>  -->
												<li class="pl-2">
													<div class="blockIDArea p-3">
														<span class="blockID ">
															<span class="tI">{{$t('loyalP_transf_Amou_Avail')}}</span> 
															<span class="priceID">$ {{convertIntoDollar(loyalityCardDetail[0].active_points)}}</span>
														</span>
													</div>
												</li> 
												
											</ul>
										</div>

										<div class="form-group field-wrapper mb-4">
											<div class="customSelect mdb-select md-form float-field form-control" @click.prevent="selectToAccount = !selectToAccount" :class="(selectToAccount?'active' : '') || ((to_account_id == '' && submitted)?'is-invalid' : '')">
												<div class="SelectAcntList SelectAcntList2">
													<div class="d-flex align-items-center justify-content-between" v-if="to_account_id == ''">{{$t('loyalP_transToAcc')}}</div>
													<div class="d-flex align-items-center justify-content-between" v-else>
														<span v-if="getWallet(to_account_id)">
															<img :src="'../../../../../static/fxView/images/'+getWallet(to_account_id).wallet.currency.toLowerCase()+'.svg'" class="mr-2 rounded-circle" alt="Icon">
															{{getWallet(to_account_id).wallet.wallet_no}}
														</span>
														<span v-else>
															<img :src="'../../../../../static/fxView/images/'+$env_var.platformIcon[to_platform]" class="mr-2" alt="Icon">
															{{to_account_id}} 
														</span>
														<small v-html="(parseInt(to_demo_live) == 1)? $t('live') : $t('demo') "></small>
													</div>
												</div>
												<!-- {{allAccountList}} -->
												<ul class="scrollbar" >
													<li v-for="(list,key) in allAccountList.records" v-if="parseInt(list.demo_live) == 1 && list.margin_detail" @click.prevent="asignValueParentComponent(list)">
														<div class="aclist" > 
															<span>
																<img :src="'../../../../../static/fxView/images/'+list.currency.toLowerCase()+'.svg'" class="mr-2 rounded-circle"  alt="Icon"> {{list.wallet_no}}  
															</span>
															<!-- <small v-html="(parseInt(list.demo_live) == 1)? $t('live') : $t('demo') "></small> -->
														</div>
														<!-- <div class="aclist" v-else> 
															<span>
																<img :src="'../../../../../static/fxView/images/'+$env_var.platformIcon[list.platform]" class="mr-2"  alt="Icon"> {{list.account_id}}  
															</span>
															<small v-html="(parseInt(list.demo_live) == 1)? $t('live') : $t('demo') "></small>
														</div> -->
													</li>
												</ul>
												<input type="hidden" name="account_id" v-validate="'required'" v-if="to_account_id == ''">
											</div>
											<p class="error" v-if="submitted && errors.has('account_id')">{{$t('loyalP_fieldReq')}}</p>
										</div> 
										<div class="d-flex button fieldArea mb-4 w-100">
							        		<div class="form-group field-wrapper mb-0 p-0">
												<input type="number" class="float-field form-control" name="points" v-model="points" v-validate="'required|min_value:100'"  :class="{ 'is-invalid': submitted && errors.has('points') }" ref="pointsInput">
												<label for="username"  class="float-label">{{$t('loyalP_transf_Enter_p_transfe')}}</label>
												<p class="error" v-if="submitted && errors.has('points')">{{$t('loyalP_fieldReq_min')}}</p>
											</div>
											
										</div>
										
										<div class="d-flex justify-content-center align-items-center submitButton w-100">
											<div class="forgot_sec pr-4" @click.prevent="$parent.transfetWallet = false">
												<a href="#" class=" red  btn_sm">
													{{$t('loyalP_transf_Cancel')}}
												</a>    
											</div>
											<button class="prism_btn btn_sm " v-on:click.prevent="submitInternalTransferRequestOtp()">{{$t('loyalP_transf_Transfer')}}</button>
										</div>

						        	</div>
						        </div>
					        </div>
						</div>
						<!-------------------------------------------------------------------->
						<div class="partcipate-fund" v-if="transaction_id != '' && !congModuleIntTransfer">
							<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 1)">
								<p class="mb-3 text-center">{{$t('rb_googleAuth1')}} <strong>{{$t('rb_googleAuth2')}}</strong> {{$t('rb_googleAuth3')}}. </p>
								<div class="form-group field-wrapper">
									<input type="text" placeholder="000 000" class="mdb-select md-form form-control" v-model="otp" v-validate="{ required: true, max: 6,numeric : true }" name="otp"  :class="{ 'is-invalid': submittedInternalOtp && errors.has('otp') }" ref="otpInput">
									<ul><li v-for="error in errors.collect('otp')">{{ error }}</li></ul>
								</div> 
								<div class="form-group text-center field-wrapper">
									<button class="prism_btn btn_sm " v-on:click.prevent="submitInternalTransferCheckOtp()">{{$t('rb_validate')}}  </button>
								</div>
								<div class="clearfix"></div>
								<div class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"> 
									<div class="desc text-center">
										<p>{{$t('rb_googleAuth4')}} <a v-on:click.prevent="resendLink()" href="#"><strong>{{$t('rb_googleAuth5')}}</strong></a></p>
									</div>
								</div>
								<div class="clearfix"></div>
							</div>
							<div class="middleBox1" v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && !authComponent)">
								<div class="congratulations">
									<div class="logo_congrats">
										<img src="../../../../../static/fxView/images/internal_transfer.svg" alt="Icon">
									</div>
									<div class="subtitle">
										<p class="mb-3">{{$t('verf_dear')}} <strong class="green">{{get_user.username}}</strong>
											{{$t('rb_googleAuth6')}} <strong>{{get_user.email}} . </strong> {{$t('loyalP_intTransMsz2')}}
										</p>
										<a v-on:click.prevent="resendLink()" href="#" class="mb-3"><strong>{{$t('rb_googleAuth7')}}</strong></a>
										
									</div>
								</div>
								<div class="clearfix"></div>
								<div class="d-flex align-items-center justify-content-between enble2fa border-top pt-3 mt-3">
									<div class="ico mr-3">
										<img src="../../../../../static/fxView/images/google_auth.png" alt="2fa">
									</div>
									<div class="desc w-75">
										<h5 class="mb-2"><strong>{{$t('rb_googleAuth8')}}</strong></h5>
										<p>{{$t('rb_googleAuth9')}} <a v-on:click.prevent="authComponent = true" href="#"><strong>{{$t('rb_googleAuth10')}}</strong></a></p>
									</div>
								</div>
							</div> 
						</div> 

						<div class="stepForm" v-if="congModuleIntTransfer">
							<div class="congratulations">
								<div class="logo_congrats">
									<img src="../../../../../static/fxView/images/check.svg" alt="Icon">
								</div>
								<div class="subtitle">
									<h3>{{$t('rb_congo')}}  <span class="green">{{get_user.username}}</span></h3>
									<p>{{$t('loyalP_intTransMsz3')}} </p>
									<ul class="includeWdth loyalityPoints">
										<!-- <li><strong>{{$t('loyalP_fromTradId')}} </strong> {{res_data.account_id}}</li> -->
										<li><strong>{{$t('Wal_detail_Amount')}} </strong> {{parseFloat(res_data.amount).toFixed(2)}}</li>
										<li><strong>{{$t('loyalP_toTradId')}} </strong>{{res_data.to_account_id}}</li>
										<li><strong>{{$t('loyalP_transferAmount')}} </strong>{{parseFloat(res_data.trans_amount).toFixed(2)}}</li>
									</ul>
								</div>
							</div>
							<div class="signupbtn full-width submitButton w-100 mt-4 text-center">
								<router-link :to="'/wallet'" class="prism_btn btn_sm">{{$t('loyalP_transf_Back')}}</router-link>
							</div> 
						</div>
						 
					</div>
				</div>
			</div>
		</div>
		<div  v-else-if="Object.keys(walletAccount).length == 0 || parseInt(get_user.verified_status) == 0">
            <!-- <div class="mainTitle  text-center my-3">
                <h3>{{$t('acc_fund_noTrdAccFnd')}}</h3>
            </div> -->
            <no-trading-account :demo_live_both="'dw'" :totalRecords = "Object.keys(walletAccount).length"></no-trading-account>
        </div>
		<div v-else class="text-center p-5 customLoader"> 
			<div class="loader"></div>  
            <h4>{{$t('acc_fund_plzWaitWhileProc')}}</h4>
        </div>
    </div>
</template>
<script>
    import twoFa from '../../users/2FA'
    export default {
        name: 'Internal-transfer',
        data() {
            return {
				pageName : this.$options.name,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                //==========================================
               
				//-----------------------
				selectToAccount : false,
                to_account_id : '',
				to_act_account_id : '',
				to_demo_live : '',
				to_platform :'', 
				to_currency : '',
				
				
                points : '',
                submitted : false,

                otp : '',
                submittedInternalOtp : false,
                transaction_id : '',
                congModuleIntTransfer : false,
                res_data : '',
                authComponent : false,
                request_page : 'internal-transfer',
				
				responseAmount : '',
				
				fromBalance : '',
				fromBalanceCurr : '',
				toBalance : '',
				toBalanceCurr : '',
				conversionAmount : false
            }
        },
        components: {
            appTwofa: twoFa
        },
        methods:{
        	getWallet(account_id){// to check if the trading account_id is wallet also return wallet id and also need to get wallet id and currency
        		try{
	        		let data = Object.values(this.walletAccount).filter(val=> val.wallet.account_id == account_id )
	        		return (data.length)?data[0]:''
        		}catch(e){return '';}
        	},
        	convertIntoDollar(getpoints){
        		if(getpoints){
        			let data = (Math.ceil((parseInt(Math.abs(getpoints))) % parseInt(this.$env_var.LOYALTY_POINTS_DEVISOR) === 0)) ? Math.ceil((parseInt(Math.abs(getpoints)))) : (Math.ceil((parseInt(Math.abs(getpoints)) - parseInt(this.$env_var.LOYALTY_POINTS_DEVISOR)) / parseInt(this.$env_var.LOYALTY_POINTS_DEVISOR)) * parseInt(this.$env_var.LOYALTY_POINTS_DEVISOR)) 
        			let dollaramount = (data / parseInt(this.$env_var.LOYALTY_POINTS_DEVISOR))
        			return dollaramount
        		}

        	},
        	asignValueParentComponent(list){
				this.to_account_id = list.account_id 
				this.to_act_account_id = list.act_account_id  
				this.to_demo_live = list.demo_live 
				this.to_platform = list.platform 
				this.to_currency = list.currency 
		    },
            resendLink(){
                let input_json = {
                    'globalParams' : {
                        'trans_id' : this.transaction_id.toString()
                    } ,'localParams' : {'parameter' : this}
                }
                this._runLoyalityResendOtp(input_json)
            },
            //================leverage===================================
            submitInternalTransferRequestOtp(){
				const _that = this
				this.submitted = true;
				this.$validator.validate().then(valid => {
					if (valid) {
						let input_json={
							'globalParams' :{
								'to_act_account_id': _that.to_act_account_id, 
								'to_account_id' : _that.to_account_id ,
								'to_currency' : _that.to_currency,
								'points' : _that.points, 
								'active_points' : _that.loyalityCardDetail[0].active_points,
								"operation" : "TRANSFER LOYALTY"
							},
							'localParams' :{ "parameter" : _that }
						}
						_that._runLoyalityRequestOtp(input_json)
					}else{
						_that.handleValidationErrorAdvanced(_that.errors)
					}
				});
            },
            submitInternalTransferCheckOtp(){
                const _that = this
                this.submittedInternalOtp = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'google_token' : _that.otp.toString() ,
                                'trans_id' : _that.transaction_id.toString()
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runLoyalityTransaferCheckOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            reset(){
				//-----select account----
				this.selectAccount =  false
                this.account_id =  ''
				this.act_account_id =  ''
				this.demo_live =  ''
				this.platform = '' 
				this.from_currency =  ''
				//-----------------------
				this.selectToAccount =  false
                this.to_account_id =  ''
				this.to_act_account_id =  ''
				this.to_demo_live =  ''
				this.to_platform = '' 
				this.to_currency =  ''
                this.amount = ''
                this.submitted = false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/wallet/loyality/loyality_point_transfer.vue